import PropTypes from 'prop-types';
import { errorContextShape } from "./ErrorContext";

/**
 * @deprecated
 * @see withErrorProvider.js -> withErrorProviderPropTypes
 */
export default PropTypes.shape(errorContextShape).isRequired;